<div class="alert-popup" cdkTrapFocus role="dialog" aria-modal="true">
    <div
        class="alert-popup__icon"
        *ngIf="iconVariant"
        [ngClass]="'alert-popup__icon--' + iconVariant">
        <svg-icon [icon]="iconName"></svg-icon>
    </div>
    <img class="alert-popup__gif" *ngIf="isShowGif(title)" [src]="gifUrl" />
    <h2 class="alert-popup__title" translate>{{ title }}</h2>
    <p
        class="alert-popup__message"
        translate
        [innerHtml]="message"
        *ngIf="message"></p>
    <p
        class="alert-popup__message"
        translate
        [innerHtml]="message1"
        *ngIf="message1"></p>
    <p
        class="alert-popup__message"
        translate
        [innerHtml]="message2"
        *ngIf="message2"></p>
    <div class="alert-popup__actions">
        <button
            type="button"
            (click)="dialogRef.close()"
            class="app-c-btn app-c-btn--primary app-c-btn--curve alert-popup__action">
            OK
        </button>
    </div>
</div>
